import { firebaseEmptyField, metricConversionRates } from '@/constants';
import { TimestampAudit } from '@/types/app';

export const alphabetize = <T>(arr: T[], alphabetizeBy: keyof T, sortDir = 1) =>
  arr.slice().sort((a, b) => {
    let firstVal = null;
    let secondVal = null;
    if (typeof a[alphabetizeBy] === 'string' && alphabetizeBy !== 'conversionRate') {
      firstVal = (a[alphabetizeBy] as unknown) as string;
      secondVal = (b[alphabetizeBy] as unknown) as string;
      firstVal = firstVal.toLowerCase();
      secondVal = secondVal.toLowerCase();
    }

    if (typeof a[alphabetizeBy] === 'object' && (alphabetizeBy === 'createdOn' || alphabetizeBy === 'lastUpdatedOn')) {
      firstVal = (a[alphabetizeBy] as unknown) as TimestampAudit;
      secondVal = (b[alphabetizeBy] as unknown) as TimestampAudit;
      firstVal = firstVal?.timestamp?.seconds || 0;
      secondVal = secondVal?.timestamp?.seconds || 0;
    }

    if (((a[alphabetizeBy] as unknown) as string) === firebaseEmptyField && alphabetizeBy === 'conversionRate') {
      firstVal = metricConversionRates.generalCubicYardToImperialTon;
    }

    if (((b[alphabetizeBy] as unknown) as string) === firebaseEmptyField && alphabetizeBy === 'conversionRate') {
      secondVal = metricConversionRates.generalCubicYardToImperialTon;
    }

    if (firstVal === null) {
      firstVal = a[alphabetizeBy];
    }

    if (secondVal === null) {
      secondVal = b[alphabetizeBy];
    }

    if (firstVal < secondVal) return -1 * sortDir;
    if (secondVal < firstVal) return 1 * sortDir;
    return 0;
  });
